import { Grid, Box, Button, Stack, Title, Text, Flex } from '@mantine/core';
import { Map, Marker, InfoWindow } from '@vis.gl/react-google-maps';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectTheaterMapData } from '../../../redux/selectors/publicSelector';
import { GoogleMapsType } from '../../../models/setting.model';
import colors from '../../../utils/styles';
import './theater-map.page.css';
import Iframe from 'react-iframe';

const TheaterMapPage = ({ mapRef }: { mapRef: React.RefObject<HTMLDivElement> }) => {
    const [showInfo, setShowInfo] = useState(false);
    const [iframeWidth, setIframeWidth] = useState(window.innerWidth * 0.8);

    const { mapContent, googleMapsType } = useSelector(selectTheaterMapData);

    useEffect(() => {
        const handleResize = () => {
            setIframeWidth(window.innerWidth * 0.8);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return <>
        <Grid py="xl" gutter={0}>
            <Grid.Col span={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box ref={mapRef}>
                    {googleMapsType === GoogleMapsType.GOOGLE_MAPS ? (
                        <Map
                            className="map"
                            defaultCenter={{ lat: 36.41946, lng: 25.4315 }}
                            defaultZoom={15}
                            gestureHandling={'greedy'}
                            disableDefaultUI={true}
                        >
                            <Marker
                                position={{ lat: 36.41946, lng: 25.4315 }}
                                title={mapContent.title}
                                onClick={() => setShowInfo(true)}
                            />
                            {showInfo && (
                                <InfoWindow
                                    position={{ lat: 36.41946, lng: 25.4315 }}
                                    onCloseClick={() => setShowInfo(false)}
                                >
                                    <Stack style={{ minWidth: '200px' }}>
                                        <Title order={4}>{mapContent.title}</Title>
                                        <Text size="sm">{mapContent.address}</Text>
                                        <Flex align="center" justify="center" gap="xs">
                                            <Text style={{ fontWeight: 'bold' }}>{mapContent.rating}</Text>
                                            <Text style={{ color: colors.appYellow }}>★★★★★</Text>
                                            <Text style={{ fontSize: '0.75rem', color: 'gray' }}>{mapContent.reviews}</Text>
                                        </Flex>
                                        <Button
                                            component="a"
                                            href={mapContent.mapHref}
                                            target="_blank"
                                            style={{ backgroundColor: colors.appPink, color: 'white' }}
                                            size="sm"
                                        >
                                            {mapContent.directions}
                                        </Button>
                                    </Stack>
                                </InfoWindow>
                            )}
                        </Map>
                    ) : (
                        <Iframe 
                            url={mapContent.mapEmbedUrl} 
                            width={`${iframeWidth}px`}
                            height="600" 
                            loading="lazy" 
                            styles={{ borderRadius: '10px', border: 'none' }} 
                        />
                    )}
                </Box>
            </Grid.Col>
        </Grid>
    </>
}

export default TheaterMapPage;